import React from "react";
import ReactDOM from "react-dom";
import PerformanceTable from "./containers/PerformanceTable";
import { getElementsProperty } from "../helpers/getElementsProperty";

export const initPerformanceTables = className => {
  getElementsProperty(className, (property, element) => {
    ReactDOM.render(<PerformanceTable symbol={property.symbol} />, element);
  });
};
